export const nl = {
  title: 'Bodembedekking 2000-2020',
  subtitle: 'UMD',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Functie',
      value: 'Kaart van wereldwijd landgebruik en landbedekking voor 2000 en 2020',
    },
    {
      label: 'Resolutie',
      value: '30 meter Hoogte',
    },
    {
      label: 'Geografische dekking',
      value: 'Globaal',
    },
    {
      label: 'Bron',
      value: 'UMD',
    },
    {
      label: 'Frequentie',
      value: '',
    },
    {
      label: 'Datum van inhoud',
      value: '',
    },
    {
      label: 'Waarschuwingen',
      value:
        "- Het in kaart brengen van de landbedekking werd beperkt door de beschikbaarheid van Landsat-gegevens over heldere hemel. De onvolledigheid van de tijdreeksen van de Landsat-waarnemingen vermindert de nauwkeurigheid van de kaart in regio's met aanhoudende bewolking. \n- Het in kaart brengen van discrete landbedekkingsklassen in heterogene landschappen werd beperkt door het hoge aandeel gemengde pixels bij de ruimtelijke resolutie van Landsat. De meeste LULC-klassen hebben een hogere kaartnauwkeurigheid over grote homogene gebieden in vergelijking met gefragmenteerde landschappen en klasse-patchranden. \n- De spectrale gelijkenis tussen verschillende LCLU-klassen kan klassendiscriminatie uitsluiten.\n- Het product boshoogte heeft problemen met betrekking tot de kwaliteit van GEDI-gegevens en de beschikbaarheid van Landsat-gegevens. Kleine veranderingen in de hoogte van bossen tussen de jaren 2000 en 2020 geven mogelijk niet de werkelijke verandering van de bosstructuur aan, maar vertegenwoordigen de ruis in de modeloutput. \n- Dynamische klassen (LCLU-klasseverlies en -winst) hebben een lagere nauwkeurigheid in vergelijking met statische kaarten. \n- Op kaarten gebaseerde schattingen zijn niet geschikt voor nationale en internationale rapportage vanwege onbekende ruimtelijke en temporele variabiliteit van kaartonzekerheid.",
    },
    {
      label: 'Licentie',
      value: 'Creative Commons Naamsvermelding Licentie (https://glad.umd.edu/dataset/GLCLUC2020)',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'De kaarten van het wereldwijde landgebruik en de landbedekking zijn gemaakt door het Global Land Analysis and Discovery Lab (GLAD) -laboratorium en de gegevens zijn beschikbaar met een ruimtelijke resolutie van 30 m voor 2000 en 2020. Het GLAD-laboratorium gebruikte de ruimtelijk consistent [Landsat Analysis Ready Data (GLAD ARD)](https://glad.umd.edu/ard) om veranderingen in de omvang en hoogte van het bos, akkerland, bebouwd land, oppervlaktewater en meerjarige sneeuw- en ijsomvang over de periode van twintig jaar te kwantificeren. Elk thematisch product werd onafhankelijk afgeleid met behulp van state-of-the-art, lokaal en regionaal gekalibreerde machine learning-tools. De dataset werd gevalideerd met behulp van een statistische steekproef die de hoge nauwkeurigheid bevestigt. Het Global Land Analysis and Discovery Lab (GLAD) laboratorium van de afdeling Geografische Wetenschappen van UMD onderzoekt methoden, oorzaken en effecten van wereldwijde veranderingen in het landoppervlak. Aardobservatiebeelden zijn de primaire gegevensbron en de omvang en verandering van de landbedekking is het belangrijkste onderwerp van belang. GLAD streeft ernaar nieuwe wetenschappelijke inzichten te genereren met betrekking tot landhulpbronnen, de volgende generatie op te leiden op basis van teledetectie op het gebied van landverandering en landmonitoringcapaciteiten te verspreiden naar operationele omgevingen in binnen- en buitenland.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
